import React from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import Aside from '#lib/components/aside.jsx';
import Dialog from '#lib/components/dialog.jsx';

export default function WarnUserUpdateDialog(props) {
    const { isOpen, onClose, action, isLoading, isError, error, isChangingEmail } = props;

    return (
        <Dialog className="max-w-lg" isOpen={isOpen} onClose={onClose}>
            <Dialog.CloseButton />
            <div className="flex items-start">
                <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-red-100">
                    <ExclamationCircleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                </div>
                <div className="mt-3 grow text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title>Before save</Dialog.Title>
                    {isChangingEmail && (
                        <p className="mb-3 text-slate-800">
                            After updating your email a new verification code will be sent to your email address. Use
                            this code in the following dialog to verify your email.
                        </p>
                    )}

                    {isError && <Aside type="problem">{error.message}</Aside>}
                </div>
            </div>
            <div className="mt-5 gap-3 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button
                    type="button"
                    disabled={isLoading}
                    onClick={action}
                    className="inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:opacity-80 sm:w-auto sm:text-sm"
                >
                    {isLoading ? 'Saving...' : 'Save anyway'}
                </button>
                <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md border border-slate-300 bg-white px-4 py-2 text-base font-medium text-slate-700 shadow-sm hover:text-slate-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm"
                    onClick={onClose}
                >
                    Cancel
                </button>
            </div>
        </Dialog>
    );
}
